////////////////////////////////////////////
//
// Contact form Functions
//
////////////////////////////////////////////

$(function() {

  // Store the user's Entry Point URL in local storage
  const entryPoint = localStorage.getItem('entryPoint');

  if (entryPoint === null) {
    localStorage.setItem('entryPoint', location.href);
  }

  // Store UTM parameters to local storage

  const URLToArray = (url, urlParamKeys) => {
    const request = {};
    const pairs = url.substring(url.indexOf('?') + 1).split('&');
    for (var i = 0; i < pairs.length; i++) {
      if (!pairs[i]) {
        continue;
      }
      const pair = pairs[i].split('=');
      // If urlParamKeys are passed, only allow keys that match.
      // Otherwise use all params.
      const keys = urlParamKeys || [];
      if (pair[0] && pair[1] && (keys.length === 0 || keys.includes(pair[0]))) {
        request[decodeURIComponent(pair[0].replace(/\+/g, ' '))] = decodeURIComponent(pair[1].replace(/\+/g, ' '));
      }
    }
    return request;
  }

  const queryString = window.location.search;

  if (queryString) {

    // Use this array to filter out only params you want, not extra ones
    // that might get tacked on randomly (like utm_source)
    const utmParamKeys = [
      'utm_campaign',
      'utm_source',
      'utm_medium',
      'utm_term',
      'utm_content'
    ];

    let utmParams = URLToArray(queryString, utmParamKeys);

    if (Object.keys(utmParams).length > 0) {
      localStorage.setItem('utmParams', JSON.stringify(utmParams));
      localStorage.setItem('utmSetDate', (new Date()).toUTCString());
    }
  }

  // Find the corresponding Forms
  const forms = document.querySelectorAll('form[data-id]');

  // Get a fresh CSRF token and Honeypot value in case the form has been cached by Blitz
  for (let i = 0; i < forms.length; i++) {
    const form = forms[i];
    const formHandle = form.getAttribute('data-handle');
    $.ajax({
      // Specify the form handle in the GET parameters
      url: '/dynamic?form=' + formHandle,
      type: 'get',
      dataType: 'json',
      success: function (response) {
        // Locate and update the CSRF input
        var csrf = response.csrf;
        form.querySelector('input[name=' + csrf.name + ']').value = csrf.value;
      }
    });
  }

  // Freeform options for AJAX form submissions

  var clearInvalidErrors = function(form) {
    $(form).find('.is-invalid-field').removeClass('is-invalid-field');
    $(form).find('.is-invalid-label').removeClass('is-invalid-label');
  }

  for (const form of forms) {
    form.addEventListener('freeform-ajax-success', function (event, form, response) {

      var formName = $(form).data('form-name');

      // Fire Google Tag Manager event
      window.dataLayer = window.dataLayer || [];
      dataLayer.push({
        'event': 'formSubmission',
        'formName': formName,
      });

      clearInvalidErrors(form);

      $('.js-float-label input, .js-float-label select').each(function(index, elem) {
        updateField(elem);
      });

      $(form).find('.upload__reset').trigger('click');
    });

    // Override the way form submit success message is displayed
    form.addEventListener('freeform-render-success', function (event) {
      var $container = $(form).parents('.form-container');

      $container.slideUp(500, function() {
        $container.nextAll('.form__success-banner').css('display','none').removeClass('hide').removeAttr('hidden').slideDown();
      })

      sessionStorage.removeItem('speaker');
    });

    // Override the way those messages are removed
    form.addEventListener('freeform-remove-messages', function (event) {
      $(event.form).find('.form__error-banner').addClass('hide').attr('hidden','');
      $(event.form).find('.form__success-banner').addClass('hide').attr('hidden','');
    });

    form.addEventListener('freeform-render-form-errors', function (event) {
      // Stop the default form error rendering
      event.preventDefault();
      $(event.form).find('.form__error-banner').removeClass('hide').removeAttr('hidden');
    });

    form.addEventListener('freeform-render-field-errors', function (event) {
      clearInvalidErrors(form);

      const errors = event.errors;

      for (const key in errors) {
        if (!errors.hasOwnProperty(key) || !key) {
          continue;
        }

        const inputList = event.form.querySelectorAll("*[name=" + key + "], *[name='" + key + "[]']");
        for (let inputIndex = 0; inputIndex < inputList.length; inputIndex++) {
          const input = inputList[inputIndex];
          input.classList.add('is-invalid-field');
          $(input).prevAll('.field label').addClass('is-invalid-label');
        }
      }
    });

    // Book a Speaker Form pre-select speaker
    const $speakerSelect = $(form).find('select[name="grayboxSpeaker"]');

    if ($speakerSelect.length > 0) {
      const speaker = sessionStorage.getItem('speaker');
      if (speaker) {
        $speakerSelect.val(speaker);
        $speakerSelect.parents('.js-float-label').addClass('field--label-floating');
      }
    }

    // Fill in the "Entry Point URL" field from local storage data
    const $entryPointInput = $(form).find('[name="entryPointUrl"]');

    if ($entryPointInput.length > 0) {
      const entryPoint = localStorage.getItem('entryPoint');

      if (entryPoint) {
        $entryPointInput.val(entryPoint);
      }
    }

    // Fill in UTM parameters from local storage data
    const utmParams = JSON.parse(localStorage.getItem('utmParams'));

    for (const param in utmParams) {
      $(form).find('[name="' + param + '"]').val(utmParams[param]);
    }

    const utmSetDate = localStorage.getItem('utmSetDate');

    if (typeof utmSetDate !== 'undefined') {
      $(form).find('[name="utmSetDate"]').val(utmSetDate);
    }

  }

  // Expandable form

  $(".form--expandable *").on('focus', function(event) {
    var thisForm = $(event.target).closest('.form--expandable');

    thisForm.addClass('is-expanded')
      .find('.form__collapse').removeAttr('hidden').slideDown().end()
      .find('.footer-form-submit').css('display', 'block').slideDown();
  });


  // Floating Labels

  var toggleFloatingLabel = function(event) {
    updateField(event.target);
  };

  var updateField = function(input) {
    var $input = $(input);
    var $field = $input.closest('.field');

    if(!!$input.val() || input === document.activeElement) {
      $field.addClass('field--label-floating');
    } else {
      $field.removeClass('field--label-floating');
    }
  };

  $('.js-float-label input, .js-float-label select')
    .on('change focus blur', toggleFloatingLabel)
    .each(function(index, elem) {
      updateField(elem);
  });

  // File upload field

  var resetUploadField = function(event) {
    event.preventDefault();

    var $button = $(event.target);
    var $upload = $button.parents('.upload');
    var $input = $upload.find('input');
    var $label = $upload.find('label');

    $input.removeClass('has-file-selected').clone().prependTo($upload);
    $input.remove();
    $label.text('');
  };

  // Attach the `fileselect` event to all file inputs on the page
  $(document).on('change', '.upload input', function(event) {
    var $input = $(event.target);
    var numFiles = $input.get(0).files ? $input.get(0).files.length : 1;
    var filename = $input.val().replace(/\\/g, '/').replace(/.*\//, '');
    $input.trigger('fileselect', [numFiles, filename]);
  });

  // Watch for our custom `fileselect` event
  $(document).on('fileselect', '.upload input', function(event, numFiles, filename) {

    var $input = $(event.target);
    var $label = $input.parents('.upload').find('label');
    filename = numFiles > 1 ? numFiles + ' files selected' : filename;

    if ($input.val()) {
      $input.addClass('has-file-selected');
    } else {
      $input.removeClass('has-file-selected');
    }

    if ($label.length) {
      $label.text(filename);
    }
  });

  // "Reset" upload form
  // There's no way to reset a file input, so we have to clone the existing
  // file input and then remove it from the DOM.
  $('.upload__reset').on('click', resetUploadField);


  // CTA button to scroll to and expand the footer contact form
  // Replace the button's current href with the first input in the footer contact form
  var $firstFooterInput = $('#footer-contact-form input').not('[type=hidden], [aria-hidden=true]').first();

  $('.js-activate-contact-form').each(function() {
    const element = this;
    let hostname = element.hostname;
    let pathname = element.pathname;

    $(element).attr('href', '#' + $firstFooterInput.attr('id'));

    // Hack for IE
    // It looses the pathname and hostname when you change the href.
    if (element.hostname === '' || element.pathname === '') {
      element.hostname = hostname;
      element.pathname = pathname;
    }
  })


  // Book a Speaker Form pre-select speaker
  $('.xlink-cards__cta [data-speaker]').on('click', function() {
    const spkr = $(this).data('speaker');
    if (spkr) {
      sessionStorage.setItem('speaker', spkr);
    }
  });

});
